import React from "react";

const ServicesSection = () => {
  return (
    <section className="section services bg-light-primary">
      <div className="service-right">
        <img
          src="/img/bg/service-right.svg"
          className="img-fluid"
          alt="services right"
        />
      </div>

      <div className="container">
        {/* Heading */}
        <div className="section-heading" data-aos="fade-down">
          <h2>How Omshree Cab Works</h2>
          <p>
            Booking your ride with Omshree Cab is simple, quick, and reliable.
            Follow these easy steps to enjoy a comfortable journey.
          </p>
        </div>

        {/* Services */}
        <div className="services-work">
          <div className="row">
            
            {/* Step 1 */}
            <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
              <div className="services-group">
                <div className="services-icon border-secondary">
                  <img
                    className="icon-img bg-secondary"
                    src="/img/icons/services-icon-01.svg"
                    alt="Choose Location"
                  />
                </div>
                <div className="services-content">
                  <h3>1. Choose Your Location</h3>
                  <p>
                    Enter your pickup and drop location to start your booking.
                    Our system helps you find the best route for a smooth and
                    comfortable journey.
                  </p>
                </div>
              </div>
            </div>

            {/* Step 2 */}
            <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
              <div className="services-group">
                <div className="services-icon border-warning">
                  <img
                    className="icon-img bg-warningg"
                    src="/img/icons/services-icon-02.svg"
                    alt="Select Vehicle"
                  />
                </div>
                <div className="services-content">
                  <h3>2. Select Your Cab</h3>
                  <p>
                    Choose from a range of comfortable and well-maintained
                    vehicles suitable for local trips, airport transfers, or
                    outstation travel.
                  </p>
                </div>
              </div>
            </div>

            {/* Step 3 */}
            <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
              <div className="services-group">
                <div className="services-icon border-dark">
                  <img
                    className="icon-img bg-dark"
                    src="/img/icons/services-icon-03.svg"
                    alt="Book your cab"
                  />
                </div>
                <div className="services-content">
                  <h3>3. Confirm & Enjoy Your Ride</h3>
                  <p>
                    Confirm your booking and relax while our professional driver
                    arrives at your location on time to provide a safe and
                    comfortable ride.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;